import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const SellosSalidaExporbananas = () => {

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 2 }}
    >
      <Temografo />
      <EtiquetaPuerta />
      <EtiquetaBisagraPhoto1 />
      <EtiquetaBisagraPhoto2 />
      <EtiquetaBisagraPhoto3 />
      <SelloCable />
      <SelloBotella />
    </Grid>
  );
};

//SELLO SALIDA VERIFICADORA
//PRIMERA SECCION

const Temografo = () => {
  const {
    open: openTermografo,
    handleClose: handleCloseTermografo,
    handleOpen: handleOpenTermografo,
  } = useOpen();

  const termografoPhoto = useWorkflowContainerFullStore(
    (state) => state.termografoPhoto
  );

  const setTermografoPhoto = useWorkflowContainerFullStore(
    (state) => state.setTermografoPhoto
  );
  const fotoUrl = useBlobUrl(termografoPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseTermografo}
        handleOpen={handleOpenTermografo}
        label="TERMÓGRAFO"
        open={openTermografo}
        setFoto={setTermografoPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const EtiquetaPuerta = () => {
  const {
    open: openAdhesivoP,
    handleClose: handleCloseAdhesivoP,
    handleOpen: handleOpenAdhesivoP,
  } = useOpen();

  const adhesivoPuertaPhoto = useWorkflowContainerFullStore(
    (state) => state.adhesivoPuertaPhoto
  );

  const setAdhesivoPuertaPhoto = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoPuertaPhoto
  );
  const fotoUrl = useBlobUrl(adhesivoPuertaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseAdhesivoP}
        handleOpen={handleOpenAdhesivoP}
        label="ETIQUETA PUERTA"
        open={openAdhesivoP}
        setFoto={setAdhesivoPuertaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

//FOTOS
//SEGUNDA SECCION

const EtiquetaBisagraPhoto1 = () => {
  const {
    open: openAbp1,
    handleClose: handleCloseAbp1,
    handleOpen: handleOpenAbp1,
  } = useOpen();

  const adhesivoBisagraPhoto1 = useWorkflowContainerFullStore(
    (state) => state.adhesivoBisagraPhoto1
  );

  const setAdhesivoBisagraPhoto1 = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoBisagraPhoto1
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto1);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseAbp1}
        handleOpen={handleOpenAbp1}
        label="ETIQUETA BISAGRA LADO IZQUIERDO"
        open={openAbp1}
        setFoto={setAdhesivoBisagraPhoto1}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const EtiquetaBisagraPhoto2 = () => {
  const {
    open: openAbp2,
    handleClose: handleCloseAbp2,
    handleOpen: handleOpenAbp2,
  } = useOpen();

  const adhesivoBisagraPhoto2 = useWorkflowContainerFullStore(
    (state) => state.adhesivoBisagraPhoto2
  );

  const setAdhesivoBisagraPhoto2 = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoBisagraPhoto2
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto2);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseAbp2}
        handleOpen={handleOpenAbp2}
        label="ETIQUETA BISAGRA LADO DERECHO"
        open={openAbp2}
        setFoto={setAdhesivoBisagraPhoto2}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const EtiquetaBisagraPhoto3 = () => {
  const {
    open: openAbp3,
    handleClose: handleCloseAbp3,
    handleOpen: handleOpenAbp3,
  } = useOpen();

  const adhesivoBisagraPhoto3 = useWorkflowContainerFullStore(
    (state) => state.adhesivoBisagraPhoto3
  );

  const setAdhesivoBisagraPhoto3 = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoBisagraPhoto3
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto3);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseAbp3}
        handleOpen={handleOpenAbp3}
        label="ETIQUETA BISAGRA CENTRO"
        open={openAbp3}
        setFoto={setAdhesivoBisagraPhoto3}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

//ULTIMA SECCION
const SelloCable = () => {
  const {
    open: openCableE,
    handleClose: handleCloseCableE,
    handleOpen: handleOpenCableE,
  } = useOpen();

  const cableExporPhoto = useWorkflowContainerFullStore(
    (state) => state.cableExporPhoto
  );
  const setCableExporPhoto = useWorkflowContainerFullStore(
    (state) => state.setCableExporPhoto
  );
  const fotoUrl = useBlobUrl(cableExporPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCableE}
        handleOpen={handleOpenCableE}
        label="SELLO CABLE"
        open={openCableE}
        setFoto={setCableExporPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const SelloBotella = () => {
  const {
    open: openBotellaExpor,
    handleClose: handleCloseBotellaExpor,
    handleOpen: handleOpenBotellaExpor,
  } = useOpen();

  const botellaExporPhoto = useWorkflowContainerFullStore(
    (state) => state.botellaExporPhoto
  );

  const setBotellaExporPhoto = useWorkflowContainerFullStore(
    (state) => state.setBotellaExporPhoto
  );
  const fotoUrl = useBlobUrl(botellaExporPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseBotellaExpor}
        handleOpen={handleOpenBotellaExpor}
        label="SELLO BOTELLA"
        open={openBotellaExpor}
        setFoto={setBotellaExporPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};
